/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SaveFeedbackSuccessResponse } from '../models/save-feedback-success-response';
import { SaveResponseFeedback } from '../models/save-response-feedback';

@Injectable({
  providedIn: 'root',
})
export class SavingResponseFeedbackApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation saveResponseFeedback
   */
  static readonly SaveResponseFeedbackPath = '/history/message_feedback';

  /**
   * Save response feedback to CosmosDB.
   *
   * Saving response feedback for further analysis.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveResponseFeedback()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveResponseFeedback$Response(params: {
    context?: HttpContext
    body: SaveResponseFeedback
  }
): Observable<StrictHttpResponse<SaveFeedbackSuccessResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SavingResponseFeedbackApiService.SaveResponseFeedbackPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SaveFeedbackSuccessResponse>;
      })
    );
  }

  /**
   * Save response feedback to CosmosDB.
   *
   * Saving response feedback for further analysis.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `saveResponseFeedback$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveResponseFeedback(params: {
    context?: HttpContext
    body: SaveResponseFeedback
  }
): Observable<SaveFeedbackSuccessResponse> {

    return this.saveResponseFeedback$Response(params).pipe(
      map((r: StrictHttpResponse<SaveFeedbackSuccessResponse>) => r.body as SaveFeedbackSuccessResponse)
    );
  }

}
